module.exports = __webpack_public_path__ + "img/bike 2.9a96e660.svg";